module.exports = __webpack_public_path__ + "img/waves.18a95dc5.svg";